import List from 'common/components/List';
import PropTypes from 'prop-types';
import React from 'react';

const Radio = ({ checked, value, label, onChange }) => {
    return (
        <label className="radio">
            <input
                className="radio__input"
                type="radio"
                value={value}
                checked={checked}
                onChange={e => onChange(e.target.value)}
            />
            <span className="radio__text">{label}</span>
        </label>
    );
};

Radio.propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
};

const RadioList = ({ options, value, onChange }) => {
    return (
        <List spacing="small">
            {options.map(option => (
                <Radio
                    key={option.value}
                    value={option.value}
                    label={option.label}
                    checked={option.value == value}
                    onChange={onChange}
                />
            ))}
        </List>
    );
};

RadioList.propTypes = {
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
};

export default RadioList;
